<div class="ds-modal viewer">
    <div class="ds-accent"></div>

    <div class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">description</span>
        <h2>{{ actual?.titulo || 'Documento' }}</h2>
        <span class="ds-modal__spacer"></span>
        <span class="viewer__contador" *ngIf="hayNavegacion">{{ contador }}</span>
        <button type="button" class="ds-icon-btn" (click)="close()" aria-label="Cerrar">
            <span class="material-icons">close</span>
        </button>
    </div>

    <div class="ds-modal__body viewer__body">
        <button type="button" class="viewer__nav viewer__nav--prev"
            *ngIf="hayNavegacion" (click)="prev()" aria-label="Documento anterior">
            <span class="material-icons">chevron_left</span>
        </button>

        <div class="viewer__doc">
            <img [@imgAnim]="index" [src]="actual?.url" [alt]="actual?.titulo" class="viewer__img" />
        </div>

        <button type="button" class="viewer__nav viewer__nav--next"
            *ngIf="hayNavegacion" (click)="next()" aria-label="Documento siguiente">
            <span class="material-icons">chevron_right</span>
        </button>
    </div>

    <div class="ds-modal__actions">
        <button type="button" class="ds-pill ds-pill--ghost" (click)="close()">Cerrar</button>
    </div>
</div>
